<template>

    <div class="wrapper" style="background-color: #f1f2f6;">
        <Sidebar />

        <div class="container " :style="{ 'margin-left': sidebarWidth }">
            <form class="row">

                <div class="title col-12 text-center" style="font-size:26px; margin-top:40px; font-weight:800;">Create A Contract For Your Client</div>

                <div class="title col-12 text-center"> Please input the following information in the fields below to generate a contract to send to your Client  </div>

                <div class="col-12 col-sm-6 text-center">
                    <label class="form-label">Anticipated Commencement Date<span class="mandatory">*</span></label>
                    <div>
                        <date-picker :disabled-date="disabledBeforeToday" :value="Contract.CommencementDate" valueType="format" @change="(x)=>{Contract.CommencementDate = x}"></date-picker>
                    </div>
                </div>
                <div class="col-12  col-sm-6 text-center">
                    <label class="form-label">Anticipated Completion Date<span class="mandatory">*</span></label>
                    <div>
                        <date-picker :disabled-date="disabledBeforeToday" :value="Contract.CompletionDate" valueType="format" @change="(x)=>{Contract.CompletionDate = x}"></date-picker>
                    </div>

                </div>



                <div class="title col-12"> Now please in your own words describe in as much detail as possible the scope of the project. <span class="mandatory">*</span><span style="color:red; font-size:12px;"></span></div>
                <div class="col-12">
                    <textarea type="text" class="form-control" v-model="Contract.ScopeOfServices" placeholder="Description"  />
                </div>
                <div class="title col-12"> Payment Terms </div>

                <div class="col-12">

                    <PaymentTerms :initial-data="paymentTermsData || {}" ref="paymentTermsComponent" />
                </div>

                <div class=" col-12 text-center" style="display:flex; margin: 8px 0; justify-content:center; align-content:center; flex-wrap: wrap;">
                    <div class="title">Terms (uncheck if you don't want to add to your contract)</div>

                </div>

                <div class="col-12 text-center">
                    <div style="font-weight:bold; font-size: 12px; margin: 4px;" for="termsOptionsSelect">Choose Contract Template</div>
                    <select id="termsOptionsSelect" class="form-select" v-model="selectedTemplateId" @change="updateTerms" style="width:fit-content; margin:8px auto;">
                        <option v-for="option in TermsOptions" :key="option.Id" :value="option.Id">
                            {{ option.Tag }}
                        </option>
                    </select>
                </div>


                <div class="info mt-2" style="font-size:14px; font-weight:bold;">You may choose to edit any of these terms for your own purposes</div>
           
                <div class="col-12">
                    <transition-group name="terms" tag="div">
                        <div class="form-check" v-for="(item, idx) in Terms" :key="item" style="margin-top:8px; background-color:white; border-radius:4px; padding:8px;" >
                            <label class=" editable" v-html="item" :id="'Editable_' + idx" contenteditable="true" style="margin-bottom:5px;"></label>

                            <div class="text-center" style="display:flex; width:100%; position:relative; ">
                                <div class="toggle-switch" style="margin: auto;" >
                                    <input type="checkbox" :id="'Terms_' + idx" v-model="Contract.Terms" :value="item" />

                                    <label :for="'Terms_' + idx" class="toggle-label" style="justify-content:center;">
                                        <span class="toggle-indicator" style="width:16px;">Y</span>
                                        <span class="toggle-indicator" style="width: 16px;">N</span>

                                    </label>
                                    <label :for="'Terms_' + idx" style="cursor: pointer;">
                                        <span class="toggle-text">Keep Clause</span>
                                    </label>
                                  
                                </div>
                                <div class="mean"><span class="material-icons icon material-symbols-outlined">smart_display</span></div>
                            </div>
                           
                        </div>
                    </transition-group>

                </div>


                <div class="col-12" style="text-align:right;">
                    <div class="btn btn-nagative" style="width: 130px; margin-right:16px;" @click="back">Cancel</div>
                    <div class="btn btn-positive" style="width: 130px; margin:0px 16px;" @click="addTerms">Add A New Term</div>
                    <div class="btn btn-positive" style="width: 170px;" @click="getPaymentTermsData">Review Contract</div>
                </div>
            </form>

            <ContractPreviewModal ref="preview" v-show="showPreviewModal" @close-preview-modal="showPreviewModal = false" @send="sendContract" />
        </div>


    </div>
</template>

<script>
    import DatePicker from 'vue-datepicker-next';
    import 'vue-datepicker-next/index.css';
    import ContractPreviewModal from '../components/modals/ContractPreviewModal.vue';
    import Sidebar from '../components/siderbar/SidebarComponent';
    import { sidebarWidth } from '../components/siderbar/state';
    import PaymentTerms from '../components/PaymentTermsComponent';
    export default {
        components: {
            DatePicker, ContractPreviewModal, Sidebar, PaymentTerms
        },
        setup() {
            return { sidebarWidth }
        },
        data() {
            return {
                showPreviewModal: false,
                Contract: {
                    ServiceType: "",
                    CommencementDate: "",
                    CompletionDate: "",
                    ScopeOfServices: "",
                    Payment: {},
                    Terms: [],
                   
                    
                },

                Terms: [],
                 
                //test payment terms data
                paymentTermsData: {

                },

                TermsOptions: [],
                selectedTemplateId: '',

            }
        },
        mounted() {

            this.getTerms();
            this.$refs.paymentTermsComponent.initData(this.paymentTermsData);
            
        },

        methods: {

            updateTerms() {
                // Update the Terms when a new template is selected
                const selectedOption = this.TermsOptions.find(option => option.Id === this.selectedTemplateId);

                if (selectedOption) {
                    this.Terms = []; // Clear terms to trigger re-render
                    setTimeout(() => {
                        this.Terms = selectedOption.Terms;
                        this.Contract.Terms = selectedOption.Terms;
                    }, 50); // Delay to allow animation to start
                }
                /*
                if (selectedOption) {
                    this.Terms = selectedOption.Terms;
                    this.Contract.Terms = selectedOption.Terms;
                }
                */
            },

            getCustomTerms() {


                this.$http.request("get", "/api/app/customterm/readlist").then((res) => {
                     
                    if (res?.Type == 200) {
                        this.TermsOptions = [];

                        //add a default terms.
                        this.TermsOptions.push({ Id: '', Tag: "Default Contract Template", CreatedDate: "", Type: 1, Terms: this.Terms });

                        this.TermsOptions.push(...res.Data.filter(m=>m.Type == 1));

                        //console.log("TermOptions", _this.TermsOptions);
                    }
                });
            },

            getPaymentTermsData() {

                const dataObj = this.$refs.paymentTermsComponent.finish();

                if (dataObj.Remain != 0 && dataObj.Mode != 'custom') {
                    this.$alert("Please ensure that the 'Remaining Amount' under 'Payment Terms' is no more than '0' (zero) after setting the payment date.", "Failed");
                    return;
                }

                this.Contract.Payment = dataObj;


                // Handle the dataObj here
                //console.log('Received dataObj:', this.Contract);

                this.review();

            },

            addTerms() {
                
                this.Terms.push("");

            },
            getTerms() {
               
                this.$core.GetClientTerms().then((res) => {

                    if (res?.Type == 200) {
                        for (var i = 0; i < res.Data.length; i++) {
                            this.Terms.push(res.Data[i].Text);
                        }
                        //this.Terms = data.Object;
                        this.Contract.Terms = this.Terms;
                    }

                    this.getCustomTerms();
                   
                });
                 

            },
            review() {

                //check data mandatory.
                if (this.Contract.CommencementDate == null || this.Contract.CommencementDate.length == 0) {
                    this.$alert("Please choose a Commencement Date for this project", "Failed");
                    return;
                }

                if (this.Contract.CompletionDate == null || this.Contract.CompletionDate.length == 0) {
                    this.$alert("Please choose an anticipated completion date for this project.", "Failed");
                    return;
                }

                if (this.Contract.ScopeOfServices == null || this.Contract.ScopeOfServices.length == 0) {
                    this.$alert("Please enter a detailed description of this project.", "Failed");
                    return;
                }

                if (this.Contract.Payment.TotalCost == 0 ) {
                    this.$alert("Please enter the total cost of the project", "Failed");
                    return;
                }


                var elts = document.getElementsByClassName("editable");
                var newTerms = [];
                for (var i = 0; i < elts.length; i++) {
                    if (document.getElementById("Terms_" + i).checked) {
                        if (elts[i].innerHTML.length > 0)
                            newTerms.push(elts[i].innerHTML);
                    }
                }

                //this.Terms = newTerms;
                this.Contract.Terms = newTerms;

                //console.log(JSON.stringify(this.Contract.Terms));

                var data = {};
                data.Data = JSON.stringify(this.Contract);
                data.Type = 1;
                data.UserId = this.$core.data.UserInfo.Id;
                data.ProjectId = this.$route.params.projectid;

               //console.log("review data", JSON.stringify(data));


                this.$loader.show(null, 30);
                this.$http.request("post", "/api/app/contract/preview", data).then(res => {
                    if (res?.Type == 200) {
                        this.$refs.preview.iframeContent(unescape(res.Data.Body));
                        this.showPreviewModal = true;
                    }
                }).finally(() => {
                    this.$loader.hide();
                });

            },

            sendContract() {
                this.showPreviewModal = false;

                var data = {};
                data.Data = JSON.stringify(this.Contract);
                data.Type = 1;
                data.UserId = this.$core.data.UserInfo.Id;
                data.ProjectId = this.$route.params.projectid;

                //console.log(JSON.stringify(data));

                this.$loader.show(null, 30);
                this.$http.request("post", "/api/app/contract/create", data).then(res => {
                    if (res?.Type == 200) {
                        this.$ui.alert(this, "Success", "Contracts Sent, Please Allow Up To 10 Minutes To Reach The Recipient/s", "success").then(() => {
                            this.$router.back();
                        });
                    }
                }).finally(() => {
                    this.$loader.hide();
                });

           
            },
            back() {
                this.$router.back();
            },
            disabledBeforeToday(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return date < today;
            }

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    .toggle-switch {
        display: flex;
        align-items: center;
        background-color: #f5f7f6;
        padding: 0 8px 0 8px;
        border-radius: 2px;
        color: #38a169;
        font-size:14px;
    }

    input[type="checkbox"] {
        display: none;
    }
    .toggle-indicator{color:white;}
    .toggle-label {
        width: 40px;
        font-size: 12px;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        padding: 2px 4px;
        background-color: #ccc; /* Light background color */

        border-radius: 15px;
        position: relative;
        font-weight: bold;
        color: #38a169; /* Green color */
        transition: background-color 0.3s;
    }

        .toggle-label::before {
            content: ' ';
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #e6f9f0; /* Toggle color */
            color: #fff;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            position: absolute;
            left: 2px;
            transition: transform 0.3s;
        }

    input[type="checkbox"]:checked + .toggle-label::before {
        transform: translateX(20px); /* Shift toggle position when checked */
    }

    input[type="checkbox"]:checked + .toggle-label {
        background-color: #38a169; /* Light green background when checked */
    }

    .toggle-text {
        margin-left: 8px; /* Space for the toggle circle */
        font-weight:bold;
    }



       .form-check .form-check-input{float:right; margin-left: -1.5em;}
    .form-check-label{padding: 4px; border: 1px solid black; margin-right:20px !important; width:calc(100% - 40px);}
    .form-check {padding-left:.5em; padding-right:0px !important; width: 100%;}
    .info{font-size: 12px; color:black;text-align:center;}
    .container-fix{ max-width: 1080px; padding-left:40px !important;}
    .title{font-size: 14px;}


    .terms-enter-active, .terms-leave-active {
        transition: all 0.5s ease;
    }

    .terms-enter, .terms-leave-to /* .terms-leave-active in <2.1.8 */ {
        opacity: 0;
        transform: translateY(20px);
    }

    .terms-move {
        transition: transform 0.5s ease;
    }
</style>

